<template>
  <tr slot-name="default" :style="{ height: height }" :class="getCss" :r-index="rowIndex" >
    <slot name="default"></slot>
  </tr>
</template>
<script>

export default dsf.component({
  name: "DsfTableRow",
  ctrlCaption: "表格布局单元行",
  mixins: [$mixins.control],
  components: {
  },
  provide() {
    return {
      $tableRow: this
    };
  },
  inject: ['$tableLayout'],
  props: {
    slots: {
      type: Array,
      default() {
        return [
          {
            name: "default",
            controls: []
          }
        ];
      }
    },
    height: {
      type: String,
      default: "57px"
    },
    rowIndex: {
      type: Number,
      default: 0
    },
    lazyLoad: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableCells: []
    };
  },
  computed: {
    getCss() {
      return [...this.$getClass(), this.showBorder ? "" : "ds-no-border", !this.noPadding ? "" : "ds-no-padding"];
    },
    $lazyLoad() {
      if (this.isDesign) {
        return false;
      } else {
        return this.lazyLoad;
      }
    }
  },
  created() {
    if (!this.isDesign) {
      if (this.$vm && this.local) {
        this.$tableLayout.tableRows.push(this);
      }
    }
  },
  beforeDestroy() {
    if (!this.isDesign) {
      dsf.array.remove(this.$tableLayout.tableRows, this);
    }
  },
  methods: {}
});
</script>
